(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lost-scenarios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initSection(section) {
    if (!section || section.dataset.lsInit === 'true') return;
    section.dataset.lsInit = 'true';

    var items = section.querySelectorAll('.ls-item');
    var triggers = section.querySelectorAll('.ls-trigger');
    var stages = section.querySelectorAll('.ls-product-stage');
    var watchButtons = section.querySelectorAll('.ls-watch');
    var modal = section.querySelector('[data-ls-modal]');
    var modalVideoWraps = section.querySelectorAll('.ls-modal-video-wrap');
    var modalVideos = section.querySelectorAll('.ls-modal-video');
    var closeButton = section.querySelector('[data-ls-close-modal]');
    var lastTriggerButton = null;

    function setActive(scenario) {
      items.forEach(function (item) {
        var isOpen = item.dataset.scenario === scenario;
        item.classList.toggle('is-open', isOpen);
        var trigger = item.querySelector('.ls-trigger');
        if (trigger) {
          trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
      });
      stages.forEach(function (stage) {
        var isActive = stage.dataset.scenario === scenario;
        stage.classList.toggle('is-active', isActive);
        if (isActive) {
          stage.removeAttribute('hidden');
        } else {
          stage.setAttribute('hidden', '');
        }
      });

      // On mobile, smooth-scroll so the product image and active item are visible
      if (window.matchMedia('(max-width: 768px)').matches) {
        var product = section.querySelector('.ls-product');
        if (product) {
          var rect = product.getBoundingClientRect();
          var top = rect.top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    }

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var scenario = trigger.dataset.scenario;
        var item = trigger.closest('.ls-item');
        // If clicking an already-open item, do nothing (always-one-open accordion)
        if (item && item.classList.contains('is-open')) return;
        setActive(scenario);
      });

      // Keyboard navigation between triggers
      trigger.addEventListener('keydown', function (e) {
        var currentIndex = Array.prototype.indexOf.call(triggers, trigger);
        var target = null;
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          target = triggers[(currentIndex + 1) % triggers.length];
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          target = triggers[(currentIndex - 1 + triggers.length) % triggers.length];
        } else if (e.key === 'Home') {
          e.preventDefault();
          target = triggers[0];
        } else if (e.key === 'End') {
          e.preventDefault();
          target = triggers[triggers.length - 1];
        }
        if (target) {
          target.focus();
        }
      });
    });

    if (modal && typeof modal.showModal === 'function') {
      function openModal(scenario, triggerEl) {
        lastTriggerButton = triggerEl || null;
        modalVideoWraps.forEach(function (wrap) {
          var isActive = wrap.dataset.scenario === scenario;
          if (isActive) {
            wrap.removeAttribute('hidden');
          } else {
            wrap.setAttribute('hidden', '');
          }
        });
        try { modal.showModal(); } catch (err) { modal.setAttribute('open', ''); }
        document.body.classList.add('ls-modal-open');
        modalVideoWraps.forEach(function (wrap) {
          if (wrap.dataset.scenario !== scenario) return;
          var video = wrap.querySelector('video');
          if (!video) return;
          try { video.currentTime = 0; } catch (err) { /* noop */ }
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () { /* autoplay blocked — controls visible */ });
          }
        });
      }

      function closeModal() {
        modalVideos.forEach(function (video) {
          try { video.pause(); video.currentTime = 0; } catch (err) { /* noop */ }
        });
        if (modal.open) { modal.close(); } else { modal.removeAttribute('open'); }
        document.body.classList.remove('ls-modal-open');
        if (lastTriggerButton && typeof lastTriggerButton.focus === 'function') {
          lastTriggerButton.focus();
        }
        lastTriggerButton = null;
      }

      watchButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          openModal(btn.dataset.scenario, btn);
        });
      });

      if (closeButton) {
        closeButton.addEventListener('click', closeModal);
      }

      modal.addEventListener('click', function (e) {
        if (e.target === modal) closeModal();
      });

      modal.addEventListener('close', function () {
        modalVideos.forEach(function (video) {
          try { video.pause(); video.currentTime = 0; } catch (err) { /* noop */ }
        });
        document.body.classList.remove('ls-modal-open');
        if (lastTriggerButton && typeof lastTriggerButton.focus === 'function') {
          lastTriggerButton.focus();
        }
        lastTriggerButton = null;
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-lost-scenarios]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-lost-scenarios]');
    if (section) initSection(section);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scroll-reveal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    // Find all instances of this section on the page (in case more than one exists)
    const sections = document.querySelectorAll('.scroll-reveal[data-section-id]');
    if (!sections.length) return;

    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // ===== Mobile per-beat video autoplay-on-view (runs everywhere; videos only exist in mobile DOM) =====
    function initBeatVideos() {
      const beatVideos = document.querySelectorAll('[data-beat-video]');
      if (!beatVideos.length) return;
      if (!('IntersectionObserver' in window)) {
        // Old browsers: just autoplay everything as a fallback
        beatVideos.forEach(function (v) {
          try { v.play().catch(function () {}); } catch (e) {}
        });
        return;
      }

      const observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            // Load source if not yet loaded (preload="none" defers it)
            if (video.readyState === 0) {
              try { video.load(); } catch (e) {}
            }
            video.play().catch(function () {
              // Autoplay blocked — leave it; the poster image (if any) is still visible
            });
          } else {
            try { video.pause(); } catch (e) {}
          }
        });
      }, {
        // Start playing slightly before the video enters the viewport for a smoother feel,
        // pause once it's mostly out of view
        rootMargin: '50px 0px 50px 0px',
        threshold: 0.35
      });

      beatVideos.forEach(function (v) { observer.observe(v); });
    }

    // Always init beat videos (they're only present in mobile-layout DOM anyway)
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initBeatVideos);
    } else {
      initBeatVideos();
    }

    // Bail out of the scroll-scrub logic below on mobile or reduced motion — CSS handles those paths
    if (isMobile || prefersReducedMotion) return;

    // ===== GSAP loader (idempotent) =====
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        if (document.querySelector('script[src="' + src + '"]')) {
          resolve();
          return;
        }
        const s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = resolve;
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    async function ensureGsap() {
      if (window.gsap && window.ScrollTrigger) return;
      if (!window.gsap) {
        await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/gsap.min.js');
      }
      if (!window.ScrollTrigger) {
        await loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.5/dist/ScrollTrigger.min.js');
      }
      window.gsap.registerPlugin(window.ScrollTrigger);
    }

    function initSection(section) {
      const video = section.querySelector('[data-scroll-video]');
      const beats = Array.from(section.querySelectorAll('.scroll-reveal__beat'));
      const railItems = Array.from(section.querySelectorAll('.scroll-reveal__rail-item'));
      const cue = section.querySelector('[data-scroll-cue]');
      const progress = section.querySelector('[data-scroll-progress]');
      const progressBar = progress ? progress.querySelector('.scroll-reveal__progress-bar') : null;
      const pinWrapper = section.querySelector('.scroll-reveal__pin-wrapper');

      if (!video || !pinWrapper) return;

      // Hardcoded mapping from beat index (1-based) to chapter number (1-based).
      // Chapter 1 = beat 1 (the wallet on its own)
      // Chapter 2 = beat 2 (the recovery tag appears)
      // Chapter 3 = beats 3, 4, 5 (the setup flow: tap → tap → ready)
      // If you change the beat count or storyline, update this map.
      const CHAPTER_FOR_BEAT_INDEX = { 1: 1, 2: 2, 3: 3, 4: 3, 5: 3 };

      const gsap = window.gsap;
      const ScrollTrigger = window.ScrollTrigger;

      // ---- Auto-detect header height (overrides the customizer setting if a sticky header is found) ----
      function detectHeaderHeight() {
        // Common selectors for Dawn and similar themes
        const headerSelectors = [
          'sticky-header',
          '.header-wrapper.header-wrapper--sticky',
          '.shopify-section-header-sticky',
          '.shopify-section-group-header-group',
          '.header-wrapper',
          'header.header',
          'header'
        ];
        for (let i = 0; i < headerSelectors.length; i++) {
          const el = document.querySelector(headerSelectors[i]);
          if (el) {
            const rect = el.getBoundingClientRect();
            const cs = getComputedStyle(el);
            // Only count it if it's actually visible and sticky/fixed
            if (rect.height > 0 && (cs.position === 'sticky' || cs.position === 'fixed')) {
              return Math.round(rect.height);
            }
          }
        }
        // Fall back to the customizer setting
        const fallback = parseInt(section.dataset.headerOffset, 10);
        return isNaN(fallback) ? 0 : fallback;
      }

      function applyHeaderOffset() {
        const h = detectHeaderHeight();
        section.style.setProperty('--sr-header-offset', h + 'px');
      }

      applyHeaderOffset();
      // Re-detect on resize (mobile/desktop header heights often differ)
      window.addEventListener('resize', applyHeaderOffset);

      // ---- Wait for video metadata so we know its duration ----
      function setupScroll() {
        const duration = video.duration;
        if (!duration || !isFinite(duration)) {
          // Fallback: try again on next loadedmetadata event
          return;
        }

        // Read beat split percentages from section dataset (set in Liquid from customizer settings).
        // 4 split values divide the scroll into 5 beats. Fallback to even 20% splits if invalid.
        function readBeatSplits() {
          const raw = section.dataset.beatSplits;
          if (!raw) return [0.20, 0.40, 0.60, 0.80];
          const parts = raw.split(',').map(function (p) {
            const n = parseFloat(p);
            return isNaN(n) ? null : n / 100;
          }).filter(function (n) { return n !== null && n > 0 && n < 1; });
          // Need exactly 4 split points (to divide into 5 beats); fall back if not.
          if (parts.length !== 4) return [0.20, 0.40, 0.60, 0.80];
          // Make sure they're in ascending order
          for (let i = 1; i < parts.length; i++) {
            if (parts[i] <= parts[i - 1]) return [0.20, 0.40, 0.60, 0.80];
          }
          return parts;
        }

        // Beat 1 start offset: the scroll-progress percentage before which beat 1 text is hidden.
        // Used to let the device finish standing up before "Meet Ryder One" appears.
        function readBeat1StartOffset() {
          const raw = section.dataset.beat1StartOffset;
          const n = parseFloat(raw);
          if (isNaN(n) || n < 0) return 0;
          if (n > 50) return 50;
          return n / 100;
        }

        const splits = readBeatSplits();
        const beat1Start = readBeat1StartOffset();
        const beatRanges = [
          { from: beat1Start, to: splits[0] },
          { from: splits[0],  to: splits[1] },
          { from: splits[1],  to: splits[2] },
          { from: splits[2],  to: splits[3] },
          { from: splits[3],  to: 1.00 }
        ];

        // ---- Read scroll/video sync settings from dataset ----
        function readNumber(name, fallback, min, max) {
          const raw = section.dataset[name];
          const n = parseFloat(raw);
          if (isNaN(n)) return fallback;
          if (n < min) return min;
          if (n > max) return max;
          return n;
        }

        // scrub smoothing: customizer value is 0–10 (representing 0.0–1.0 seconds of GSAP scrub lag)
        const scrubSmoothing = readNumber('scrubSmoothing', 3, 0, 10) / 10;

        // Video start/end offsets are in % of duration (0–25%). Used to skip intro/outro segments.
        const videoStartOffset = readNumber('videoStartOffset', 0, 0, 25) / 100;
        const videoEndOffset = readNumber('videoEndOffset', 0, 0, 25) / 100;
        const videoStartTime = duration * videoStartOffset;
        const videoEndTime = duration * (1 - videoEndOffset);
        const videoPlayableDuration = Math.max(0.1, videoEndTime - videoStartTime);

        // ---- Scroll-controlled video playback ----
        // Account for header offset: the sticky element is offset by header height,
        // so we want progress=0 when the section's top aligns with the bottom of
        // the header (not the top of the viewport).
        const headerOffset = detectHeaderHeight();

        const trigger = ScrollTrigger.create({
          trigger: pinWrapper,
          start: 'top ' + headerOffset + 'px',
          end: 'bottom bottom',
          scrub: scrubSmoothing,
          onUpdate: function (self) {
            const progressRatio = self.progress;

            // Map scroll progress to a position within the [videoStartTime, videoEndTime] window
            const targetTime = videoStartTime + (progressRatio * videoPlayableDuration);
            // Only update if meaningfully different (reduces work)
            if (Math.abs(video.currentTime - targetTime) > 0.02) {
              video.currentTime = targetTime;
            }

            // Update progress bar
            if (progressBar) {
              progressBar.style.width = (progressRatio * 100).toFixed(2) + '%';
            }

            // Track which beat is currently active so we can drive the chapter rail.
            let activeBeatIndex = -1;

            // Activate the matching beat
            beats.forEach(function (beat, i) {
              const range = beatRanges[i];
              if (!range) return;
              // No beat is active before the beat-1 start offset (used to hide text during the
              // device stand-up animation at the very beginning of the video).
              if (progressRatio < beat1Start) {
                beat.setAttribute('data-active', 'false');
                return;
              }
              const active = progressRatio >= range.from && progressRatio < range.to;
              // Special case: include 1.0 in the last beat
              const isLast = i === beats.length - 1;
              const finalActive = isLast ? progressRatio >= range.from : active;
              beat.setAttribute('data-active', finalActive ? 'true' : 'false');
              if (finalActive) {
                activeBeatIndex = i;
              }
            });

            // Map the active beat → active chapter via the hardcoded mapping above.
            // Each beat is keyed by its 1-based index in the DOM (data-beat-index),
            // which we read off the active beat element. -1 means no active beat
            // (we're before beat 1 starts), in which case no chapter is highlighted.
            if (railItems.length) {
              let activeChapter = 0;
              if (activeBeatIndex >= 0 && beats[activeBeatIndex]) {
                const beatIdx = parseInt(beats[activeBeatIndex].dataset.beatIndex, 10);
                activeChapter = CHAPTER_FOR_BEAT_INDEX[beatIdx] || 0;
              }
              railItems.forEach(function (item) {
                const chapterNum = parseInt(item.dataset.chapter, 10);
                item.setAttribute('data-active', chapterNum === activeChapter ? 'true' : 'false');
              });
            }

            // Hide scroll cue after the user has begun scrolling through
            if (cue) {
              cue.setAttribute('data-visible', progressRatio < 0.05 ? 'true' : 'false');
            }
            if (progress) {
              progress.setAttribute('data-visible', progressRatio > 0.01 && progressRatio < 0.99 ? 'true' : 'false');
            }
          },
          onEnter: function () {
            // Initial state
            if (cue) cue.setAttribute('data-visible', 'true');
            // If there's a beat-1 start offset, leave all beats inactive at scroll=0.
            // Beat 1 will activate naturally once scroll progress crosses the offset.
            beats.forEach(function (beat, i) {
              const shouldShowBeat1 = i === 0 && beat1Start === 0;
              beat.setAttribute('data-active', shouldShowBeat1 ? 'true' : 'false');
            });
            // Match initial rail state to the initial beat state (chapter 1 active
            // only if beat 1 is active from scroll=0).
            if (railItems.length) {
              railItems.forEach(function (item) {
                const chapterNum = parseInt(item.dataset.chapter, 10);
                const shouldActivate = chapterNum === 1 && beat1Start === 0;
                item.setAttribute('data-active', shouldActivate ? 'true' : 'false');
              });
            }
          },
          onLeaveBack: function () {
            if (cue) cue.setAttribute('data-visible', 'false');
          }
        });

        // ---- Click-to-jump: clicking a chapter scrolls smoothly to its start ----
        // We compute the scroll Y for the start of each chapter using the trigger's
        // own start/end pixel positions, mapping chapter→beat→progress ratio.
        // chapter 1 → beat 1 starts at beat1Start
        // chapter 2 → beat 2 starts at splits[0]
        // chapter 3 → beat 3 starts at splits[1]
        // If you change the chapter→beat mapping, update CHAPTER_START_PROGRESS too.
        const CHAPTER_START_PROGRESS = {
          1: beat1Start,
          2: splits[0],
          3: splits[1]
        };

        railItems.forEach(function (item) {
          item.addEventListener('click', function () {
            const chapterNum = parseInt(item.dataset.chapter, 10);
            const startProgress = CHAPTER_START_PROGRESS[chapterNum];
            if (typeof startProgress !== 'number') return;

            // Add a tiny offset (1% of total) past the chapter start so the active
            // state lands cleanly inside the chapter rather than right on the edge.
            const targetProgress = Math.min(startProgress + 0.005, 0.999);
            const targetScroll = trigger.start + (trigger.end - trigger.start) * targetProgress;

            window.scrollTo({
              top: targetScroll,
              behavior: 'smooth'
            });
          });
        });

        // Seek video to its starting offset on first load (so the visible frame matches scroll=0)
        try {
          video.currentTime = videoStartTime;
        } catch (e) {}

        // Recalculate on resize
        let resizeTimer;
        window.addEventListener('resize', function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            ScrollTrigger.refresh();
          }, 200);
        });
      }

      // Video metadata may already be loaded, or we wait
      if (video.readyState >= 1) {
        setupScroll();
      } else {
        video.addEventListener('loadedmetadata', setupScroll, { once: true });
        // Safety: also try on 'canplay' in case metadata event misfires
        video.addEventListener('canplay', setupScroll, { once: true });
      }

      // ---- iOS Safari: video must be "played" once to enable currentTime scrubbing ----
      // We play+immediately pause to unlock the video element.
      video.play().then(function () {
        video.pause();
      }).catch(function () {
        // Autoplay blocked. Scrubbing may still work but we add a one-time
        // user-gesture unlock as fallback.
        const unlock = function () {
          video.play().then(function () { video.pause(); }).catch(function () {});
          document.removeEventListener('touchstart', unlock);
          document.removeEventListener('click', unlock);
        };
        document.addEventListener('touchstart', unlock, { once: true, passive: true });
        document.addEventListener('click', unlock, { once: true });
      });
    }

    // ===== Boot =====
    ensureGsap().then(function () {
      sections.forEach(initSection);
    }).catch(function (err) {
      // GSAP failed to load — gracefully degrade by showing mobile layout
      console.warn('[scroll-reveal] GSAP failed to load, falling back.', err);
      sections.forEach(function (s) {
        const pin = s.querySelector('.scroll-reveal__pin-wrapper');
        const mob = s.querySelector('.scroll-reveal__mobile');
        if (pin) pin.style.display = 'none';
        if (mob) mob.style.display = 'block';
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
